import { useMemo } from "react";

const maskByType: Record<string, string> = {
  cep: "_____-___",
  cpf: "___.___.___-__",
  phone: "(__) _____-____",
  money: "___.___.___,__",
};

const DIGIT_REPLACEMENT = { _: /\d/ } as const;

export function useInputMask(type: string, mask?: string, replacement?: Record<string, RegExp>) {
  return useMemo(() => {
    const autoMask = maskByType[type];
    if (autoMask) {
      return {
        mask: autoMask,
        replacement: replacement || DIGIT_REPLACEMENT,
      };
    }
    if (mask) {
      return {
        mask,
        replacement: replacement || DIGIT_REPLACEMENT,
      };
    }
    return null;
  }, [type, mask, replacement]);
}